import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "discount", "displayAmount", "displayDiscount", "finalTotal", "form"]

  connect() {
    this.calculate()
  }

  calculate() {
    const amount = parseFloat(this.amountTarget.value) || 0
    const discount = parseFloat(this.discountTarget.value) || 0
    const finalTotal = amount - discount

    this.displayAmountTarget.textContent = this.formatCurrency(amount)
    this.displayDiscountTarget.textContent = this.formatCurrency(discount)
    this.finalTotalTarget.textContent = this.formatCurrency(finalTotal)
  }

  formatCurrency(value) {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2
    }).format(value)
  }
}

